import React from 'react'
import { css } from 'aphrodite'
import { Col, Row } from 'reactstrap'
import { Link } from 'react-router-dom'

import style from './style'

import user from '../../../../utils/user'
import access from '../../../../utils/access'

const routeList = [
  {
    title: `Application`,
    path: `application`
  },
  {
    title: `Users`,
    path: `users`
  },
  {
    title: `Groups`,
    path: `groups`
  },
  {
    title: `Settings`,
    path: `settings`
  },
  {
    title: `Billing`,
    path: `billing`,
    access: access.comTransactions
  },
  {
    title: `Revenue`,
    path: `revenue`,
    access: access.comStats
  }
]

export const Sidebar = props => {
  const userGroups = props.groups
    .slice()
    .reduce(
      (arr, g) => [
        ...arr,
        ...((g.users || []).includes(props.userId) ? [g] : [])
      ],
      []
    )
  const userPerms = user.parsePermList({ groups: userGroups })

  return (
    <Row>
      <Col>
        <Row>
          <Col>
            <RenderSelector
              onChange={props.onCommunityChange}
              value={props.comId}
              options={props.communities}
            />
          </Col>
        </Row>
        {props.hide ? null : (
          <Row className={css(style.navigation.wrapper)}>
            <Col className={css(style.navigation.innerWrapper)}>
              {routeList.map((route, index) => {
                if (
                  route.access &&
                  (!userPerms || !route.access(userPerms)) &&
                  !props.isMod
                ) {
                  return null
                }

                return (
                  <RenderLink
                    key={`${route.title}_${index}`}
                    title={route.title}
                    path={`${props.comId}/${route.path}`}
                    currentPath={props.location.pathname}
                  />
                )
              })}
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  )
}

const RenderLink = props => {
  const path = `/dashboard/community/${props.path}`
  return (
    <Row>
      <Col className={css(style.navigation.row)}>
        <Link
          to={path}
          className={css(
            style.navigation.link,
            props.currentPath.startsWith(path)
              ? style.navigation.activeLink
              : null
          )}
        >
          {props.title}
        </Link>
      </Col>
    </Row>
  )
}

const RenderSelector = props => {
  return (
    <select
      value={props.value}
      onChange={props.onChange}
      className={css(style.selector.select)}
    >
      {props.options.map((item, index) => (
        <option key={`${index}_${item.id}`} value={item.id}>
          {item.name}
        </option>
      ))}
    </select>
  )
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Community/partials/Sidebar/index.js